/** DOM id for a TOC slide row (used for scroll-into-view after slide edit). */
export function tocSlideDomId(slideId: string | null | undefined): string {
  return `toc-slide-${String(slideId || '').trim()}`;
}

/**
 * Scroll a TOC slide row into view. When `container` is set, scrolls within that element
 * (e.g. SME chat right panel); otherwise uses `scrollIntoView` on the document.
 */
export function scrollToTocSlide(
  slideId: string | null | undefined,
  container?: HTMLElement | null,
): boolean {
  const id = String(slideId || '').trim();
  if (!id) return false;
  const el = document.getElementById(tocSlideDomId(id));
  if (!el) return false;

  if (container) {
    const cRect = container.getBoundingClientRect();
    const eRect = el.getBoundingClientRect();
    const offset = eRect.top - cRect.top + container.scrollTop - 20;
    container.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
  } else {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  return true;
}

/** Retry until the TOC row exists (e.g. after *ngIf switches back from slide mode). */
export function scrollToTocSlideWhenReady(
  slideId: string | null | undefined,
  container?: HTMLElement | null,
  options?: { maxAttempts?: number; intervalMs?: number },
): void {
  const maxAttempts = options?.maxAttempts ?? 30;
  const intervalMs = options?.intervalMs ?? 50;
  let attempt = 0;
  const tick = () => {
    if (scrollToTocSlide(slideId, container)) return;
    attempt += 1;
    if (attempt < maxAttempts) setTimeout(tick, intervalMs);
  };
  tick();
}
